import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from '../i18n/LanguageContext';

const CTASection = () => {
  const { t } = useTranslation();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: 'easeOut',
      },
    },
  };

  return (
    <section className="py-12 md:py-20 px-6 md:px-12 bg-light-card">
      <div className="max-w-4xl mx-auto">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          className="text-center space-y-6"
        >
          {/* Title */}
          <motion.h2
            variants={itemVariants}
            className="font-filson font-bold text-4xl md:text-5xl text-gray-900"
          >
            {t('cta.title')}
          </motion.h2>

          {/* Description */}
          <motion.p
            variants={itemVariants}
            className="font-filson font-medium text-lg md:text-xl text-gray-700 leading-relaxed"
          >
            {t('cta.description')}
          </motion.p>

          {/* Accent Line */}
          <motion.div
            variants={itemVariants}
            className="flex justify-center pt-4"
          >
            <div
              style={{
                height: '4px',
                width: '60px',
                backgroundColor: '#CB4B4B',
                borderRadius: '2px',
              }}
            />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
